<div class="errors">
  @if (showCeilingError()) {
    <div class="plan-error">
      <mat-icon>error</mat-icon>
      <strong class="error-message">
        Exceeded ceiling by up to {{ getCeilingErrorAmount() | number: '1.1-1' }}m for {{ getCeilingErrorDuration() | humanDuration }}
      </strong>
    </div>
  }
  @if (showPO2Error()) {
    <div class="plan-error">
      <mat-icon>error</mat-icon>
      <strong class="error-message">
        Exceeded safe PO2 for {{ getPO2ErrorDuration() | humanDuration }}, up to PO2 = {{ getPO2ErrorAmount() | number: '1.2-2' }}
      </strong>
    </div>
  }
  @if (showHypoxicError()) {
    <div class="plan-error">
      <mat-icon>error</mat-icon>
      <strong class="error-message">
        Hypoxic gas as low as {{ getHypoxicErrorAmount() | number: '1.3-3' }} for {{ getHypoxicErrorDuration() | humanDuration }}
      </strong>
    </div>
  }
  @if (showENDError()) {
    <div class="plan-error">
      <mat-icon>error</mat-icon>
      <strong class="error-message">
        <!-- eslint-disable-next-line prettier/prettier -->
        END as deep as {{ getENDErrorAmount() | number: '1.1-1' }}m for {{ getENDErrorDuration() | humanDuration }}
      </strong>
    </div>
  }
</div>
